import { render, staticRenderFns } from "./IPWidget.vue?vue&type=template&id=777ca73c&scoped=true&"
import script from "./IPWidget.vue?vue&type=script&lang=js&"
export * from "./IPWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777ca73c",
  null
  
)

export default component.exports